function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.65,17.3A8.652,8.652,0,0,1,5.283.68a8.652,8.652,0,0,1,6.734,15.94A8.6,8.6,0,0,1,8.65,17.3Zm-3-8.989a.417.417,0,0,0-.3.131L4.887,8.9a.433.433,0,0,0,0,.614l2.059,2.032a.415.415,0,0,0,.605,0l4.861-4.861a.431.431,0,0,0,0-.6l-.458-.459a.433.433,0,0,0-.606,0l-4.1,4.1-1.3-1.289A.417.417,0,0,0,5.648,8.311Z",
  transform: "translate(0 0)",
  fill: "#3ec7af"
});

var SvgCheckmarkCircle = function SvgCheckmarkCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.3,
    height: 17.3,
    viewBox: "0 0 17.3 17.3",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckmarkCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark_circle.7a01c9b8.svg";
export { ForwardRef as ReactComponent };